module.exports = __webpack_public_path__ + "img/orange_040.e4b02a14.png";